export default __webpack_public_path__ + "87cb8802e83fb1ca383394b6c4253442.png";